import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';
import { Navigate } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = 'flik_admin_token';

const AdminContext = createContext(null);

export const AdminProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || '');

  const login = async (username, password) => {
    const res = await axios.post(`${API}/admin/login`, { username, password });
    localStorage.setItem(TOKEN_KEY, res.data.token);
    setToken(res.data.token);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken('');
  };

  const authAxios = axios.create({ baseURL: API });
  authAxios.interceptors.request.use((config) => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
  });
  authAxios.interceptors.response.use(
    (r) => r,
    (err) => {
      if (err.response && err.response.status === 401) {
        localStorage.removeItem(TOKEN_KEY);
        setToken('');
      }
      return Promise.reject(err);
    }
  );

  return (
    <AdminContext.Provider value={{ token, isAuthed: !!token, login, logout, authAxios }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);

export const ProtectedRoute = ({ children }) => {
  const { isAuthed } = useAdmin();
  if (!isAuthed) return <Navigate to="/admin/login" replace />;
  return children;
};
